import { render } from "./BellIcon.vue?vue&type=template&id=e68f6de4&ts=true"
import script from "./BellIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./BellIcon.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/BellIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e68f6de4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e68f6de4', __exports__)) {
    api.reload('e68f6de4', __exports__)
  }
  
  module.hot.accept("./BellIcon.vue?vue&type=template&id=e68f6de4&ts=true", () => {
    api.rerender('e68f6de4', render)
  })

}


export default __exports__